import classNames from "classnames";
import React from "react";
import "./Highlight.css";
import { Flex } from "./Flex";
import Icon from "./Icon";
import Label from "./Label";

type HighlightProps = {
    className?: string;
    label: string;
    type?: "info" | "error";
};

function Highlight(props: HighlightProps) {
    const { className, label, type = "info" } = props;

    return (
        <Flex.Row
            className={classNames("highlight", className)}
            gap="medium"
            alignItems="start"
        >
            {type === "error" ? (
                <Icon.PriorityHigh.Medium.S10 />
            ) : (
                <Icon.Problem.Medium.E10 />
            )}
            <Label.Medium.SemiBold>{label}</Label.Medium.SemiBold>
        </Flex.Row>
    );
}

export default Highlight;
